import IconCards from '@/components/_organisms/IconCards';
import { ModuleIconCardsFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

interface IconCardsModuleProps extends PropsWithClassName {
  props: CraftModuleFragment<ModuleIconCardsFragment>;
}

const IconCardsModule: FC<IconCardsModuleProps> = ({ props, className }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <IconCards
      heading={props.heading ?? undefined}
      cards={
        props.cards
          .map((card) => {
            const glyph = getSingle(card?.icon);

            if (!glyph) return null;

            return {
              text: parseHtml(card?.text),
              glyph: {
                src: glyph.url!,
                width: glyph.width!,
                height: glyph.height!,
                alt: '',
              },
            };
          })
          .filter(notEmpty) ?? []
      }
    />
  );
};

export default IconCardsModule;
